import {
    useScroll,
    type UseScrollOptions,
    type UseScrollReturn,
} from '@/composables/vueuse/use-scroll.ts'
import { type ConfigurableWindow, defaultWindow } from '@vueuse/core'

export interface UseWindowScrollOptions
    extends ConfigurableWindow, UseScrollOptions {}

// export interface UseWindowScrollReturn extends UseScrollReturn {
// }

/**
 * Reactive window scroll.
 *
 * @see https://vueuse.org/useWindowScroll
 * @param options
 */
export function useWindowScroll(
    options: UseWindowScrollOptions = {}
): UseScrollReturn {
    const { window = defaultWindow, ...rest } = options

    return useScroll(window, rest)
}
